import React, { useState, useEffect } from 'react';
import { getAddress } from '../../Api/AddressApi';
import s from "./AddressTree.module.css"


const TreeNode = ({ fullPath, children, setSelectedAddress, pathValues, setFullAddress }) => {
  let defaultOpenState = false;
  try {
    const raw = localStorage.getItem(fullPath);
    defaultOpenState = raw ? JSON.parse(raw) : false;
  } catch (e) {
    defaultOpenState = false;
  }
  const [isOpen, setIsOpen] = useState(defaultOpenState);

  const handleToggle = () => {
    localStorage.setItem(fullPath, JSON.stringify(!isOpen));
    setIsOpen(!isOpen);
  };

  const handleClick = (e) => {
    e.preventDefault();
    setFullAddress(pathValues);
  };

  const displayName = fullPath.split(' > ').pop();

  return (
    <li>
      <div className={s.line}>
        <div className={`${s.caret} ${isOpen ? s.caretDown : ''}`} onClick={handleToggle}>
          {isOpen ? (
            <img src={"/arrowbackcaret.svg"} alt="Arrow back caret" />
          ) : (
            <img src={"/arrowright.svg"} alt="Arrow right" />
          )}
        </div>
        <button type="button" className={s.nodeButton} onClick={handleClick}>
          {displayName}
        </button>
      </div>

      {isOpen && (
        <Tree
          data={children}
          setSelectedAddress={setSelectedAddress}
          pathValues={pathValues}
          setFullAddress={setFullAddress}
        />
      )}
    </li>
  );
};

const Tree = ({ data, isFirstLevel, fullPath, setSelectedAddress, pathValues = [], setFullAddress }) => {
  return (
    <ul className={isFirstLevel ? `${s.nested} ${s.active} ${s.treeline}` : `${s.nested} ${s.active}`}>
      {Object.keys(data).map(key => {
        const newPath = fullPath ? `${fullPath} > ${key}` : key;
        const currentPathValues = [...pathValues, key];
        return (
          <TreeNode
            key={newPath}
            name={key}
            fullPath={newPath}
            setSelectedAddress={setSelectedAddress}
            children={data[key]}
            setFullAddress={setFullAddress}
            pathValues={currentPathValues}
          />
        );
      })}
    </ul>
  );
};

const TreeDiv = ({ setSelectedAddress, handleFullAddressChange }) => {
  const [fullAddress, setFullAddress] = useState([]);
  useEffect(() => {
    if (typeof handleFullAddressChange === 'function') {
      handleFullAddressChange(fullAddress)
    }
  }, [fullAddress, handleFullAddressChange])
  return (
    <div>
      <AddressTree setSelectedAddress={setSelectedAddress} setFullAddress={setFullAddress} />
    </div>
  );
};

const AddressTree = ({ setSelectedAddress, setFullAddress }) => {
  const [treeData, setTreeData] = useState(null);

  useEffect(() => {
    const createTree = async () => {
      let address = await getAddress();
      let tree = {};

      address.forEach(function (item) {
        const fullPath = `${item.city || ''}, ${item.street || ''}, ${item.building || ''}`;

        let pathArray = fullPath.split(', ').filter(Boolean);
        let currentNode = tree;

        pathArray.forEach((key) => {
          if (!currentNode[key]) {
            currentNode[key] = {};
          }
          currentNode = currentNode[key];
        });
      });
      setTreeData(tree);
    };

    createTree();
  }, []);

  return treeData ? <Tree data={treeData} isFirstLevel={true} fullPath="" setSelectedAddress={setSelectedAddress} setFullAddress={setFullAddress} /> : null;
};

export default TreeDiv;  